import {
  CHAT_CLICKED_IN_CALL,
  CHAT_OPEN,
  EDIT_MESSAGE,
  EDIT_MESSAGE_TEXT_SUCCESS,
  FETCH_CONTACTS_FAILURE,
  FETCH_CONTACTS_REQUEST,
  FETCH_CONTACTS_SUCCESS,
  FETCH_MESSAGE,
  FETCH_MESSAGE_FAILURE,
  FETCH_MESSAGE_SUCCESS,
  HANDLE_CALL,
  IN_CALL,
  IOS_PRV_MESSAGES,
  ONLINE_USERS,
  PENDING_CHATS,
  PRESENT_SCREEN,
  SELECT_SENDER,
  SELECTED_CHAT,
  SEND_ATTACHMENT,
  SEND_MESSAGE,
  SET_BLOCK,
  SET_CALL_USER,
  SET_MENU_CLICK,
  SET_REPORT,
  SET_SNACKBAR,
  SET_VIDEO_SWITCH,
  SOCKET_CONNECT,
  SOCKET_DISCONNECT,
  START_RECORDING,
  STOP_RECORDING,
  STOP_TYPING,
  TYPING,
  UPDATE_CONTACT,
  UPDATE_CONTACTS,
  USER_DETAIL,
} from "./actionTypes";

export const addRequest = () => {};

export const updateContacts = (data) => {
  return {
    type: UPDATE_CONTACTS,
    payload: data,
  };
};

export const updateContact = (contact) => ({
  type: UPDATE_CONTACT,
  payload: contact,
});

export const fetchContactsRequest = (data) => ({
  type: FETCH_CONTACTS_REQUEST,
  payload: data,
});

export const fetchContactsSuccess = (contacts) => ({
  type: FETCH_CONTACTS_SUCCESS,
  payload: contacts,
});

export const fetchContactsFailure = (error) => ({
  type: FETCH_CONTACTS_FAILURE,
  payload: error,
});

export const onlineUsersAction = (onlineUsers) => ({
  type: ONLINE_USERS,
  payload: onlineUsers,
});

export const pendingChatsAction = (pendingChats) => ({
  type: PENDING_CHATS,
  payload: pendingChats,
});

export const connectSocket = () => ({
  type: SOCKET_CONNECT,
});

export const disconnectSocket = () => ({
  type: SOCKET_DISCONNECT,
});

export const chatClickedInCallAction = (data) => ({
  type: CHAT_CLICKED_IN_CALL,
  payload: data,
});
export const fetchMessagesRequest = (data) => ({
  type: FETCH_MESSAGE,
  payload: data,
});
export const fetchMessagesSuccess = (data) => ({
  type: FETCH_MESSAGE_SUCCESS,
  payload: data,
});
export const fetchMessagesFailure = (data) => ({
  type: FETCH_MESSAGE_FAILURE,
  payload: data,
});

export const editMessage = (data) => ({
  type: EDIT_MESSAGE,
  payload: data,
});

export const editedMessageTextSuccess = (data) => ({
  type: EDIT_MESSAGE_TEXT_SUCCESS,
  payload: data,
});

export const sendMessage = (data) => ({
  type: SEND_MESSAGE,
  payload: data,
});

export const newMessageReceived = (data) => ({
  type: IOS_PRV_MESSAGES,
  payload: data,
});

export const selectedChatAction = (data) => ({
  type: SELECTED_CHAT,
  payload: data,
});

export const setCallUserAction = (data) => ({
  type: SET_CALL_USER,
  payload: data,
});

export const inCallAction = (data) => ({
  type: IN_CALL,
  payload: data,
});

export const sendAttachment = (data) => ({
  type: SEND_ATTACHMENT,
  payload: data,
});

export const startRecording = (data) => ({
  type: START_RECORDING,
});

export const stopRecording = () => ({
  type: STOP_RECORDING,
});

export const typingStatus = (data) => ({
  type: TYPING,
});

export const stopTypingStatus = () => ({
  type: STOP_TYPING,
});

// CHAT HEADER ACTIONS
export const setVideoSwitch = (data) => ({
  type: SET_VIDEO_SWITCH,
  payload: data,
});
export const handleMenuClick = (data) => ({
  type: SET_MENU_CLICK,
  platform: data,
});
export const handleCallUser = (data) => ({
  type: HANDLE_CALL,
  payload: data,
});

export const handleBlock = (data) => ({
  type: SET_BLOCK,
  payload: data,
});

export const handleReport = (data) => ({
  type: SET_REPORT,
  payload: data,
});

export const getUserDetail = (data) => ({
  type: USER_DETAIL,
  payload: data,
});

export const presentScreen = (data) => ({
  type: PRESENT_SCREEN,
  payload: data,
});

export const setSnackbarAction = (data) => ({
  type: SET_SNACKBAR,
  payload: data,
});

export const chatOpenAction = (data) => ({
  type: CHAT_OPEN,
  payload: data,
});
